export const pathwaySteps = [
  { title: 'Functional Concern', text: 'Define the activity or participation difficulty you want to understand.' },
  { title: 'Task Demands', text: 'Organize the motor, sequencing, imitation, and environmental demands relevant to the activity.' },
  { title: 'Motor Observations', text: 'Document what the child actually does during the task.' },
  { title: 'Possible Patterns', text: 'Explore recurring observations and differences across activities and contexts.' },
  { title: 'Missing Information', text: 'Identify what you still need to clarify before strengthening a working hypothesis.' },
  { title: 'Working Hypothesis', text: 'Organize possible explanations and identify the next questions worth investigating.' },
];
